import React, { useState, useEffect } from 'react';
import date_time from '../images/date_time.svg';
import bill from '../images/bill.svg';

import check_status from '../images/check_status.gif';
import placed from '../images/food-placed.svg';
import preapare from '../images/prepare.svg';
import ready from '../images/food-ready.svg';
import served from '../images/food-served.svg';

import hide from '../images/hide.gif';
import show from '../images/show.gif';

export default function OrderStatus() {
    const [orderData, setOrderData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showStatus, setShowStatus] = useState(false);
    const [showCheckStatus, setShowCheckStatus] = useState(true);

    const fetchOrderStatus = async () => {
        const tableNumber = localStorage.getItem('tableNumber');
        if (!tableNumber || tableNumber === '--') return;

        setLoading(true);
        try {
            const response = await fetch(`https://f2fl3xamwg.execute-api.ap-southeast-1.amazonaws.com/orders/table/${tableNumber}`);
            const result = await response.json();

            if (result.data) {
                setOrderData(result.data);
                setShowCheckStatus(false);
                setShowStatus(true);
            } else {
                setOrderData(null);
                // Keep default state (Check Status box visible)
            }
        } catch (error) {
            console.error("Failed to fetch order status:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrderStatus();
        // Optional: Set up polling here if needed
        const interval = setInterval(fetchOrderStatus, 30000); // Poll every 30 seconds
        return () => clearInterval(interval);
    }, []);

    const handleCheckNow = () => {
        fetchOrderStatus(); // Trigger a manual refresh
    };

    const handleHideStatus = () => {
        setShowStatus(false);
    };

    const handleShowStatus = () => {
        setShowStatus(true);
    };




    return (
        <div className="container-fluid p-0 mt-4 mb-0">
            <div className="container">
                <div className="row">
                    {/* "CHECK YOUR ORDER STATUS" box - Show if no active order or explicitly asked to hide status */}
                    {!orderData && showCheckStatus && (
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4 check_order_status_main_div">
                            <div className="bg_white rounded p-4 shadow d-flex align-items-center justify-content-center" style={{ border: `1px solid #000000` }}>
                                <img src={check_status} alt='' className='d-block me-2' style={{ width: '100px' }} />
                                <div className="div">
                                    <h2 className='main_heading mb-0 w-100' style={{ color: '#000000' }}>CHECK YOUR ORDER STATUS</h2>
                                    <p className='mb-3'>
                                        Wondering what’s happening with your order? Tap “Check Now” to see where it’s at!
                                    </p>

                                    <button type="button" className="btn black_btn mt-0" onClick={handleCheckNow} disabled={loading}>
                                        {loading ? 'CHECKING...' : 'CHECK NOW'} &nbsp;
                                        {!loading && (
                                            <svg width="29" height="12" viewBox="0 0 29 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M28.0303 6.53033C28.3232 6.23744 28.3232 5.76257 28.0303 5.46967L23.2574 0.696701C22.9645 0.403808 22.4896 0.403808 22.1967 0.696701C21.9038 0.989594 21.9038 1.46447 22.1967 1.75736L26.4393 6L22.1967 10.2426C21.9038 10.5355 21.9038 11.0104 22.1967 11.3033C22.4896 11.5962 22.9645 11.5962 23.2574 11.3033L28.0303 6.53033ZM0.5 6.75L27.5 6.75L27.5 5.25L0.5 5.25L0.5 6.75Z" fill="white"></path>
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Order status box - Show if we have order data and showStatus is true */}
                    {orderData && showStatus && (
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4 order_status_main_div">
                            <div className="bg_white rounded p-4 shadow">
                                {/* Bill No */}
                                <div className="d-flex align-items-center justify-content-center border-bottom mb-0 pb-2">
                                    <div className="col d-flex align-items-center flex-wrap">
                                        <img src={date_time} alt='' className='me-2' style={{ width: '20px' }} />
                                        <p className='ex_small_text mb-0'>
                                            {new Date(orderData.placedAt).toLocaleDateString()} | {new Date(orderData.placedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                        </p>
                                        <h2 className='sub_heading mb-0 mt-2 w-100'>Order Status</h2>
                                    </div>

                                    <div className="col d-flex align-items-center justify-content-end">
                                        <div className="text-center me-2">
                                            <img src={bill} alt="" style={{ width: '40px' }} />
                                        </div>
                                        <div className="div">
                                            <p className="orange_text mb-0">Bill No</p>
                                            <h1 className="heading fw-bold mb-0">{orderData.billNo}</h1>
                                        </div>
                                    </div>
                                </div>
                                {/* Bill No */}

                                <div className="clearfix"></div>

                                {/* Status */}
                                <div className="d-flex align-items-center justify-content-center status_box mt-2">

                                    {/* PLACED */}
                                    <div className={`col text-center ${['PLACED', 'PREPARING', 'READY'].includes(orderData.status) ? 'status_completed' : ''}`}>
                                        <img src={placed} alt='' className={`status_img ${orderData.status === 'PLACED' ? 'ongoing_status_img' : ''}`} />
                                        <div className="w-100 d-flex justify-content-center">
                                            <p className={`placed_tag mb-0 order_tag ${['PREPARING', 'READY'].includes(orderData.status) ? 'done_tag' : ''}`} style={{ width: 'fit-content' }}>PLACED</p>
                                        </div>
                                        <div className="status_arrow w-100">
                                            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.70285 0.401031L18.7806 13.878H0.625137L9.70285 0.401031Z" fill="black" />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* PREPARING */}
                                    <div className={`col text-center ${['PREPARING', 'READY'].includes(orderData.status) ? 'status_completed' : ''}`}>
                                        <img src={preapare} alt='' className={`status_img ${orderData.status === 'PREPARING' ? 'ongoing_status_img' : ''}`} />
                                        <div className="w-100 d-flex justify-content-center">
                                            {/* PREPARING: Completed if status is READY. Active if PREPARING. Pending if PLACED. */}
                                            <p className={`prepare_tag mb-0 order_tag ${['READY'].includes(orderData.status) ? 'done_tag' : ''} ${['PLACED'].includes(orderData.status) ? 'pending_tag' : ''}`} style={{ width: 'fit-content' }}>PREPARING</p>
                                        </div>
                                        <div className="status_arrow w-100">
                                            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.70285 0.401031L18.7806 13.878H0.625137L9.70285 0.401031Z" fill="black" />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* READY */}
                                    <div className={`col text-center ${['READY'].includes(orderData.status) ? 'status_completed' : ''}`}>
                                        <img src={ready} alt='' className={`status_img ${orderData.status === 'READY' ? 'ongoing_status_img' : ''}`} />
                                        <div className="w-100 d-flex justify-content-center">
                                            {/* READY: Active if READY. Pending if PLACED or PREPARING. */}
                                            <p className={`ready_tag mb-0 order_tag ${['PLACED', 'PREPARING'].includes(orderData.status) ? 'pending_tag' : ''}`} style={{ width: 'fit-content' }}>READY</p>
                                        </div>
                                        <div className="status_arrow w-100">
                                            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.70285 0.401031L18.7806 13.878H0.625137L9.70285 0.401031Z" fill="black" />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* SERVED (Visual Only, usually not returned by API as active) */}
                                    <div className="col text-center">
                                        <img src={served} alt='' className="status_img" />
                                        <div className="w-100 d-flex justify-content-center">
                                            <p className="served_tag mb-0 order_tag pending_tag" style={{ width: 'fit-content' }}>SERVED</p>
                                        </div>
                                        <div className="status_arrow w-100">
                                            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.70285 0.401031L18.7806 13.878H0.625137L9.70285 0.401031Z" fill="black" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                {/* Status */}

                                {/* requested items */}
                                {orderData.items && orderData.items.length > 0 && (
                                    <>
                                        <p className='ol_li mb-0 mt-3'>Items</p>
                                        <p className='mb-0'>
                                            {orderData.items.map(item => item.name).join(' | ')}
                                        </p>
                                    </>
                                )}

                                {orderData.customerRequest && (
                                    <>
                                        <p className='ol_li mb-0 mt-3'>Requests</p>
                                        <p className='mb-0'>{orderData.customerRequest}</p>
                                    </>
                                )}
                                {/* requested items */}

                            </div>
                        </div>
                    )}

                    {/* Show/Hide button */}
                    <div className="col-12 text-end">
                        {orderData && showStatus && (
                            <button type="button" className="btn white_btn mb-4" style={{ width: 'fit-content' }} onClick={handleHideStatus}>
                                HIDE STATUS &nbsp;
                                <img src={hide} alt="Hide icon" style={{ width: '30px' }} />
                            </button>
                        )}

                        {orderData && !showStatus && (
                            <button type="button" className="btn white_btn mb-4" style={{ width: 'fit-content' }} onClick={handleShowStatus}>
                                SHOW STATUS &nbsp;
                                <img src={show} alt="Show icon" style={{ width: '30px' }} />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
